

export class FinancialYearDto implements IFinancialYearDto {
    id!: number;
    financialYear!: string | undefined;

    constructor(data?: IFinancialYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.financialYear = _data["financialYear"];
        }
    }

    static fromJS(data: any): FinancialYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["financialYear"] = this.financialYear;
        return data; 
    }
}

export interface IFinancialYearDto {
    id: number;
    financialYear: string | undefined;
}

